// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"1f8bcd8b","239":"604880ad","389":"43e29fec","488":"532930ac","732":"9e86c6d0","977":"c35d405a"}[chunkId] + ".chunk.js";
};